import React, { useContext, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DataAppContext } from '../DataContext';

const SecureHeader = () => {
  const localContext = useContext(DataAppContext);
  const navigate = useNavigate();

  const { appstate, logout_user, toggleSidebar } = localContext;
  const { loginstatus, sidebarOpen } = appstate;

  const studentpages = ['/myStatus', '/class', '/assignment'];
  const teacherpages = [];

  const checkUserTypeandRedirect = () => {
    const usertype = localStorage.getItem('usertype')?.toLowerCase();
    if (usertype === 'student') {
      let pageurl = window.location.pathname;
      if (studentpages.indexOf(pageurl) === -1) {
        navigate('/accessdenied')
      }
    }
  }

  useEffect(() => {
    // Authentication/Expiry is now handled by the Context Provider.
    checkUserTypeandRedirect();
  }, [])

  return (
    <div className='row secureheader'>
      <div className='col-6 bg-info bg-opacity-10 py-1 d-flex align-items-center'>
        {loginstatus && (
          <button
            className={`btn me-3 ${sidebarOpen ? 'btn-outline-secondary' : 'btn-outline-dark'}`}
            style={{ fontSize: '1.2rem', lineHeight: 1, padding: '4px 8px' }}
            onClick={toggleSidebar}
          >
            &#9776;
          </button>
        )}
        <h3 className="m-0">HashedBit CMS Admin</h3>
      </div>
      <div className='col-6 bg-info bg-opacity-10 py-1'>
        <div className='text-right d-flex justify-content-end'>
          {
            loginstatus && (
              <button className='btn btn-outline-danger' onClick={logout_user}>Logout</button>
            )
          }
          {
            (!loginstatus && (window.location.pathname !== '/')) && (<Link className='btn btn-outline-success' to="/login">Login</Link>)
          }

        </div>
      </div>
    </div>
  )
}

export default SecureHeader
